<script setup lang="ts">
import { Building2, CircleDashed, MapPin } from 'lucide-vue-next'
import type { ContentScope } from '@/types/contentScope'

const props = defineProps<{
  scope: ContentScope | null | undefined
}>()

const { t } = useI18n()

const appearance = computed(() => {
  if (props.scope === 'network') {
    return {
      icon: Building2,
      label: t('contentScope.scopes.network'),
      class: 'bg-badge-violet text-badge-violet-foreground'
    }
  }

  if (props.scope === 'local') {
    return {
      icon: MapPin,
      label: t('contentScope.scopes.local'),
      class: 'bg-badge-orange text-badge-orange-foreground'
    }
  }

  return { icon: CircleDashed, label: t('contentScope.scopes.unclassified'), class: 'text-muted-foreground' }
})
</script>

<template>
  <Badge
    variant="secondary"
    :class="appearance.class"
    data-testid="content-scope-badge"
    :data-scope="scope ?? 'unclassified'"
  >
    <component :is="appearance.icon" aria-hidden="true" />
    {{ appearance.label }}
    <slot />
  </Badge>
</template>
